import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { RolesService } from '../../../../services/roles.service';
import { Role } from '../../../../roles/models/role.model';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { UserService } from '../../../../services/user.service';
import { RoleEditComponent } from '../role-edit/role-edit.component';
@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.css']
})
export class RoleListComponent implements OnInit {
  dataSource: MatTableDataSource<Role>;
  displayedColumns = ['actions','name'];
  isEdit:Boolean = false;
  constructor(
    private roleService:RolesService,
    public userService:UserService,
    public dialog: MatDialog
    ) {
    
   }
  loadData(){
    this.roleService.GetAll().subscribe(roles=>{
      this.dataSource = new MatTableDataSource(roles);
    })        
  }
  ngOnInit() {
    this.loadData();
  }
  onEdit(): void {
    this.isEdit = true;
    
  }
  OnAdd(): void {
    this.isEdit = false;
    const dialogRef = this.dialog.open(RoleEditComponent, {
      width: '250px',
      data: new Role()
    });

    dialogRef.afterClosed().subscribe(result => {
      let role:Role = result;
      if(!(this.isEdit) && role && role.name){
        this.roleService.Create(role).subscribe(()=>{
          this.loadData();
        });
      }
    });
    
  }  
}
